/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-31 15:08:51
 *
 *******************************************************/
import React, { Component } from 'react';
import { Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { DropdownMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  handleRemove: Function
};

type ComposedProps = Props & WithI18nProps;

class PopoverActionButton extends Component<ComposedProps> {
  state = {
    active: false
  };

  togglePopover = () => {
    this.setState(({ active }) => {
      return { active: !active };
    });
  };

  render() {
    const { i18n } = this.props;
    const { active } = this.state;
    const activator = (
      <Button onClick={this.togglePopover}>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {i18n.translate('AdminHTML.ThemeSetup.Themes.action')} <Icon source={DropdownMinor} />
        </span>
      </Button>
    );

    return (
      <Popover active={active} activator={activator} onClose={this.togglePopover}>
        <Popover.Pane>
          <ActionList
            items={[
              {
                content: i18n.translate('AdminHTML.ThemeSetup.Themes.removeAll'),
                onAction: () => this.handleRemove(true)
              },
              {
                content: i18n.translate('AdminHTML.ThemeSetup.Themes.removeSearch'),
                onAction: () => this.handleRemove(false)
              }
            ]}
          />
        </Popover.Pane>
      </Popover>
    );
  }

  handleRemove = removeAll => {
    const { handleRemove } = this.props;
    this.togglePopover();
    handleRemove(removeAll);
  };
}

export default withI18n()(PopoverActionButton);
